import type { ReadonlyUint8Array } from "@utils/arrayUtils";
import { bytesToBase64 } from "@utils/base64";

export function toBase64(array: ReadonlyUint8Array): string {
  return bytesToBase64(array);
}

export function downloadBlob(blob: Blob, filename?: string): HTMLAnchorElement {
  // Create an object URL for the blob object
  const url = URL.createObjectURL(blob);

  // Create a new anchor element
  const a = document.createElement("a");

  // Set the href and download attributes for the anchor element
  // You can optionally set other attributes like `title`, etc
  // Especially, if the anchor element will be attached to the DOM
  a.href = url;
  a.download = filename ?? "download";

  // Click handler that releases the object URL after the element has been clicked
  // This is required for one-off downloads of the blob content
  const clickHandler = (): void => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener("click", clickHandler);
    }, 150);
  };

  // Add the click event listener on the anchor element
  a.addEventListener("click", clickHandler, false);

  // Programmatically trigger a click on the anchor element
  a.click();
  // Return the anchor element, useful if you want a reference to the element in order to attach it to the DOM or use it in some other way
  return a;
}
